module.exports = __webpack_public_path__ + "static/media/share.458591b1.png";